/**
 *
 *             Greenwich Loyalty
 *        https://greenwichloyalty.com
 *
**/

import { useState } from 'react';

import { TbRefreshDot } from "react-icons/tb";

import PetstopLogo from '../assets/icons/PetstopLogo';
import useIsMobile from '../hooks/useIsMobile';

// Our Libraries
import * as apiComms from '../apiComms';
import * as logger from '../logger';

const PROG = 'SignInPage.js';

const SignInPage = (props) => {

  const [isSignInView, setIsSignInView] = useState(true);
  const [isValidatePinView, setIsValidatePinView] = useState(false);
  const [isProcessingView, setIsProcessingView] = useState(false);
  const [dataEntryEmailAddress, setDataEntryEmailAddress] = useState('');
  const [dataEntryValidationPin, setDataEntryValidationPin] = useState('');
  const isMobile = useIsMobile();

  const handleSignInButtonPress = async () => {
    const FUNCTION = 'handleSignInButtonPress';
    setIsSignInView(false);
    setIsProcessingView(true);
    const res = await apiComms.sendSignUpInPinCodeToEmail(dataEntryEmailAddress);
    logger.debug('Received from API', { PROG, FUNCTION, res });
    if (res == null) {
      alert('Sorry, An Error Occured');
      setIsProcessingView(false);
      setIsSignInView(true);
    }
    else if (res.isErr) {
      alert('Sorry, An Error Occured: '+res.errMsg);
      setIsProcessingView(false);
      setIsSignInView(true);
    }
    else {
      setDataEntryValidationPin('');
      setIsProcessingView(false);
      setIsValidatePinView(true);
    }
  };

  const handleValidatePinButtonPress = async () => {
    const FUNCTION = 'handleValidatePinButtonPress';
    setIsValidatePinView(false);
    setIsProcessingView(true);
    const res = await apiComms.validatePin(dataEntryEmailAddress, dataEntryValidationPin);
    logger.debug('Received from apiComms.validatePin', { PROG, FUNCTION, res });

    if (res == null) {
      alert('Sorry, An Error Occured');
      setIsProcessingView(false);
      setIsSignInView(true);
    }
    else if (res.isErr) {
      alert('Sorry, An Error Occured: '+res.errMsg);
      setIsProcessingView(false);
      setIsSignInView(true);
    }
    else {
      const token = res.response.token;
      localStorage.setItem('token', token);
      setIsProcessingView(false);
      props.handleUpdate({ updateType : 'checkIsSignedIn' });
    }
  };

  const handleCancelValidatePinEntry = () => {
    setDataEntryEmailAddress('');
    setDataEntryValidationPin('');
    setIsValidatePinView(false);
    setIsSignInView(true);
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();

    if (dataEntryEmailAddress.trim() === '') {
      return;
    }

    handleSignInButtonPress();
  };

  const handlePinSubmit = (e) => {
    e.preventDefault();

    if (dataEntryValidationPin.trim() === '') {
      return;
    }

    handleValidatePinButtonPress();
  };

  return (
    <main style={{
      ...styles.page,
      ...(isMobile ? styles.pageMobile : {})
    }}>
      { !isMobile ? (
      <section style={ styles.brandPanel }>
        <div style={ styles.brandOverlay } />
        <div style={ styles.brandContent }>
          <div style={ styles.logoShell }>
            <PetstopLogo width={ 170 } />
          </div>
          <div>
            <div style={ styles.kicker }>Loyalty Dashboard</div>
            <h1 style={ styles.heroTitle }>Welcome back to your loyalty control room.</h1>
            <p style={ styles.heroCopy }>
              Sign in securely to review customer activity, promotions, reporting and app content.
            </p>
          </div>
        </div>
      </section>
      ) : null }

      <section style={{
        ...styles.formPanel,
        ...(isMobile ? styles.formPanelMobile : {})
      }}>
        <div style={{
          ...styles.formCard,
          ...(isMobile ? styles.formCardMobile : {})
        }}>
          <div style={{
            ...styles.mobileLogo,
            ...(isMobile ? styles.mobileLogoVisible : {})
          }}>
            <PetstopLogo width={ 150 } color='#009fe3' />
          </div>

          { isSignInView ? (
            <form onSubmit={ handleEmailSubmit } style={ styles.form }>
              <div>
                <div style={ styles.formEyebrow }>Secure sign-in</div>
                <h2 style={{
                  ...styles.formTitle,
                  ...(isMobile ? styles.formTitleMobile : {})
                }}>Enter your dashboard email</h2>
                <p style={ styles.formIntro }>
                  We will send a one-time PIN to your email address.
                </p>
              </div>

              <label style={ styles.label } htmlFor='email'>Email address</label>
              <input
                style={ styles.input }
                type='email'
                name='email'
                id='email'
                placeholder='name@example.com'
                value={ dataEntryEmailAddress }
                onChange={ (element) => { setDataEntryEmailAddress(element.target.value.toLowerCase()); } }
                autoComplete='email'
                autoFocus
              />

              <button
                type='submit'
                name='btn_login'
                style={{
                  ...styles.primaryButton,
                  ...(dataEntryEmailAddress.trim() === '' ? styles.primaryButtonDisabled : {})
                }}
                disabled={ dataEntryEmailAddress.trim() === '' }
              >
                Send PIN
              </button>
            </form>
          ) : null }

          { isValidatePinView ? (
            <form onSubmit={ handlePinSubmit } style={ styles.form }>
              <div>
                <button
                  type='button'
                  onClick={ handleCancelValidatePinEntry }
                  style={ styles.backButton }
                >
                  Back
                </button>
                <div style={ styles.formEyebrow }>Check your inbox</div>
                <h2 style={{
                  ...styles.formTitle,
                  ...(isMobile ? styles.formTitleMobile : {})
                }}>Enter your 6 digit PIN</h2>
                <p style={ styles.formIntro }>
                  We emailed a secure PIN to <strong>{ dataEntryEmailAddress }</strong>.
                </p>
              </div>

              <label style={ styles.label } htmlFor='pin'>PIN</label>
              <input
                style={{ ...styles.input, ...styles.pinInput }}
                type='text'
                inputMode='numeric'
                name='pin'
                id='pin'
                value={ dataEntryValidationPin }
                onChange={ (element) => { setDataEntryValidationPin(element.target.value.replace(/\D/g, '').slice(0, 6)); } }
                autoComplete='one-time-code'
                autoFocus
              />

              <button
                type='submit'
                name='btn_validate_pin'
                style={{
                  ...styles.primaryButton,
                  ...(dataEntryValidationPin.trim() === '' ? styles.primaryButtonDisabled : {})
                }}
                disabled={ dataEntryValidationPin.trim() === '' }
              >
                Validate PIN
              </button>
            </form>
          ) : null }

          { isProcessingView ? (
            <div style={ styles.processingPanel }>
              <TbRefreshDot size='4.5em' color='#009fe3' className='spinnerIcon' />
              <h2 style={ styles.processingTitle }>Checking credentials</h2>
              <p style={ styles.formIntro }>This should only take a moment.</p>
            </div>
          ) : null }
        </div>

        <div style={{
          ...styles.footer,
          ...(isMobile ? styles.footerMobile : {})
        }}>
          <img style={ styles.footerLogo } src='./greenwitch-loyalty-black.png' alt='' />
          <span>&copy; 2026 Greenwich Loyalty</span>
        </div>
      </section>
    </main>
  );
};

const styles = {
  page : {
    minHeight : '100vh',
    display : 'grid',
    gridTemplateColumns : 'minmax(360px, 0.95fr) minmax(360px, 1.05fr)',
    backgroundColor : '#f6f8fb',
    color : '#1f2933'
  },
  pageMobile : {
    display : 'block',
    backgroundImage : 'linear-gradient(160deg, rgba(0, 159, 227, 0.12), rgba(32, 201, 151, 0.08))'
  },
  brandPanel : {
    position : 'relative',
    minHeight : '100vh',
    backgroundImage : 'linear-gradient(135deg, rgba(0, 159, 227, 0.92), rgba(8, 76, 112, 0.82)), url("/prime-meridian.jpg")',
    backgroundRepeat : 'no-repeat',
    backgroundSize : 'cover',
    backgroundPosition : 'center',
    overflow : 'hidden'
  },
  brandOverlay : {
    position : 'absolute',
    inset : 0,
    background : 'linear-gradient(180deg, rgba(255, 255, 255, 0.14), rgba(255, 255, 255, 0))'
  },
  brandContent : {
    position : 'relative',
    minHeight : '100%',
    padding : '56px clamp(32px, 6vw, 76px)',
    display : 'flex',
    flexDirection : 'column',
    justifyContent : 'space-between',
    gap : 48,
    color : 'white'
  },
  logoShell : {
    display : 'inline-flex',
    alignItems : 'center',
    width : 190
  },
  kicker : {
    fontSize : 13,
    fontWeight : 'bold',
    textTransform : 'uppercase',
    letterSpacing : 1.2,
    opacity : 0.86,
    marginBottom : 12
  },
  heroTitle : {
    fontSize : 52,
    lineHeight : 1.02,
    fontWeight : 800,
    maxWidth : 640,
    margin : 0
  },
  heroCopy : {
    fontSize : 17,
    lineHeight : 1.55,
    maxWidth : 520,
    marginTop : 22,
    marginBottom : 0,
    color : 'rgba(255, 255, 255, 0.88)'
  },
  formPanel : {
    minHeight : '100vh',
    display : 'flex',
    flexDirection : 'column',
    justifyContent : 'center',
    padding : '48px clamp(22px, 6vw, 88px)',
    position : 'relative'
  },
  formPanelMobile : {
    minHeight : '100vh',
    padding : '28px 18px 78px'
  },
  formCard : {
    width : '100%',
    maxWidth : 470,
    margin : '0 auto',
    backgroundColor : 'white',
    border : '1px solid #e3e8ef',
    borderRadius : 8,
    boxShadow : '0 18px 60px rgba(31, 41, 51, 0.12)',
    padding : '42px clamp(26px, 5vw, 48px)'
  },
  formCardMobile : {
    padding : '32px 24px',
    marginTop : 26
  },
  mobileLogo : {
    display : 'none',
    marginBottom : 26
  },
  mobileLogoVisible : {
    display : 'flex',
    justifyContent : 'center'
  },
  form : {
    display : 'flex',
    flexDirection : 'column',
    gap : 16
  },
  formEyebrow : {
    fontSize : 13,
    fontWeight : 'bold',
    color : '#009fe3',
    textTransform : 'uppercase',
    letterSpacing : 1
  },
  formTitle : {
    fontSize : 28,
    fontWeight : 800,
    lineHeight : 1.15,
    marginTop : 8,
    marginBottom : 8
  },
  formTitleMobile : {
    fontSize : 24
  },
  formIntro : {
    fontSize : 15,
    color : '#697586',
    lineHeight : 1.5,
    margin : 0
  },
  label : {
    fontSize : 13,
    fontWeight : 'bold',
    color : '#364152',
    marginTop : 8
  },
  input : {
    width : '100%',
    height : 52,
    border : '1px solid #cdd5df',
    borderRadius : 6,
    padding : '0 14px',
    fontSize : 16,
    outline : 'none',
    backgroundColor : '#fbfcfe'
  },
  pinInput : {
    fontSize : 24,
    letterSpacing : 8,
    fontWeight : 'bold',
    textAlign : 'center'
  },
  primaryButton : {
    height : 52,
    border : 'none',
    borderRadius : 6,
    backgroundColor : '#009fe3',
    color : 'white',
    fontWeight : 'bold',
    fontSize : 15,
    marginTop : 10,
    cursor : 'pointer',
    boxShadow : '0 10px 24px rgba(0, 159, 227, 0.28)'
  },
  primaryButtonDisabled : {
    opacity : 0.55,
    cursor : 'not-allowed',
    boxShadow : 'none'
  },
  backButton : {
    border : 'none',
    backgroundColor : 'transparent',
    color : '#009fe3',
    padding : 0,
    marginBottom : 18,
    fontWeight : 'bold',
    cursor : 'pointer'
  },
  processingPanel : {
    minHeight : 260,
    display : 'flex',
    flexDirection : 'column',
    alignItems : 'center',
    justifyContent : 'center',
    textAlign : 'center',
    gap : 12
  },
  processingTitle : {
    fontSize : 24,
    fontWeight : 800,
    margin : 0
  },
  footer : {
    position : 'absolute',
    left : 0,
    right : 0,
    bottom : 24,
    display : 'flex',
    alignItems : 'center',
    justifyContent : 'center',
    gap : 10,
    color : '#697586',
    fontSize : 13
  },
  footerMobile : {
    bottom : 20
  },
  footerLogo : {
    width : 28,
    height : 28,
    objectFit : 'contain'
  }
};

export default SignInPage;
